import { useState } from "react";
import { Routes, Route } from "react-router-dom";
import ServicesPage from "./pages/ServicesPage";
import PortfolioPage from "./pages/PortfolioPage";
import ServiceDetailsPage from "./pages/ServiceDetailsPage";
import ContactModal from "./components/ContactModal";
import ScrollToTop from "./components/ScrollToTop";
import "./App.css";

function App() {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);

  return (
    <>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<ServicesPage openModal={openModal} />} />
        <Route path="/portfolio" element={<PortfolioPage openModal={openModal} />} />
        <Route path="/services/:slug" element={<ServiceDetailsPage openModal={openModal} />} />
      </Routes>
      <ContactModal isOpen={isModalOpen} onClose={closeModal} />
    </>
  );
}

export default App;